import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import {ScrollDirection} from '../classes/scroll-manager';
import {getEl} from '../helpers';
import AnimationDebugger from '../components/animation-debugger';
import {ResponsiveSize} from "../classes/responsive-watcher";
import Globals from "../classes/globals";

export default class IntroSequence extends Scene {

	sectionSelector = '#intro-sequence';
	mediaTimeline = anime.timeline({
		easing: 'easeInOutCubic',
		duration: 5000,
		autoplay: false,
		delay: 0,
	});

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

		const flyinDuration = 2800;
		const hideLogoTime = 0.475 * flyinDuration;
		
		const isMobile = this.manager.app.responser.isSmallerOrEqualTo(ResponsiveSize.md);
		
		if (isMobile)
		{
			this.mediaTimeline
				.add({
					targets: '.intro-logo',
					filter: ['blur(20px)', 'blur(0px)'],
					opacity: [0, 1],
					translateY: ['16px', '0px'],
					duration: 1000,
					endDelay: 3000,
					begin: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'block';
						// @ts-ignore
						getEl('.intro-logo').style.zIndex = 1;
					},
					complete: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'none';
						// @ts-ignore
						getEl('.intro-logo').style.zIndex = 10;
					},
				}, 1500).add({
				targets: '.intro-headings, .intro-wipes',
				opacity: 1,
				duration: 1000,
			}, 3800)
				.add({
					targets: '.intro-heading',
					translateX: ['-50%', '-50%'],
					opacity: [
						{value: 0, duration: 0},
						{value: 1, duration: 1500},
						{value: 1, duration: 3000},
						{value: 0, duration: 1500},
					],
					translateY: [
						{value: '-20%', duration: 0},
						{value: '-50%', duration: 1500},
						{value: '-50%', duration: 3000},
						{value: '-100%', duration: 1500},
					],
					delay: anime.stagger(5000),
				}, 4000)
				.add({
					targets: '.intro-wipes .intro-wipe',
					clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
					delay: anime.stagger(5000, {start: 0}),
					duration: 1000,
				}, 4000)
				.add({
					targets: '.intro-wipes .intro-wipe img',
					scale: [1, 1.2],
					translateY: ['0%', '-5%'],
					easing: 'linear',
					delay: anime.stagger(5000, {start: 0}),
					duration: 6000,
				}, 4000)
				.add({
					targets: '.intro-wipe-0',
					translateY: ['0%', '-5%'],
					duration: 1000,
					easing: 'easeInCubic',
					delay: 5000,
				}, 4000)
				.add({
					targets: '.intro-wipe-0, .intro-wipe-1, .intro-wipe-2',
					translateY: ['0vh', '-30vh'],
					duration: 1300,
					easing: 'easeInCubic',
					delay: anime.stagger(5000, {start: 5000}),
				}, 4000)
				.add({
					targets: '.intro-logo',
					filter: ['blur(20px)', 'blur(0px)'],
					opacity: [0, 1],
					translateY: ['16px', '0px'],
					duration: 1000,
					
					begin: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'block';
					},
				})
				.add({
					targets: '.intro-skip',
					translateX: ['-50%', '-50%'],
					translateY: ['0%', '20%'],
					opacity: [1, 0],
					//delay: -500,
					duration: 1000,
				}, 20000)
				.add({
					targets: '.intro-scroll',
					translateX: ['-50%', '-50%'],
					translateY: ['20%', '0%'],
					opacity: [0, 1],
					//delay: -500,
					duration: 2000,
				}, 20400)
				.add({
					targets: '.intro-headings',
					opacity: 0,
					duration: 1000,
				}, 19000);
		}
		else {
			//DESKTOP INTRO
			this.mediaTimeline
				.add({
					targets: '.intro-skip',
					translateX: ['-50%', '-50%'],
					translateY: ['20%', '0%'],
					opacity: [0, 1],
					//delay: -500,
					duration: 2000,
				}, 2500)
				.add({
					targets: '.intro-col.up',
					easing: 'cubicBezier(0.015, 0.205, 0.495, 0.990)',
					translateY: ['75vh', '0%'],
					duration: flyinDuration,
				}, 2500)
				.add({
					targets: '.intro-col.down',
					easing: 'cubicBezier(0.015, 0.205, 0.495, 0.990)',
					translateY: ['-100vh', '0%'],
					duration: flyinDuration,
				}, 2500)
				.add({
					targets: '.intro-img',
					easing: 'cubicBezier(0.015, 0.205, 0.495, 0.990)',
					marginTop: ['11vw', '0vw'],
					marginBottom: ['11vw', '0vw'],
					duration: flyinDuration * 0.9,
				}, 2550)
				.add({
					targets: '.intro-logo',
					filter: ['blur(20px)', 'blur(0px)'],
					opacity: [0, 1],
					translateY: ['16px', '0px'],
					duration: 1000,
					endDelay: hideLogoTime,
					begin: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'block';
						// @ts-ignore
						getEl('.intro-logo').style.zIndex = 1;
					},
					complete: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'none';
						// @ts-ignore
						getEl('.intro-logo').style.zIndex = 10;
					},
				}, 1000)
				.add({
					easing: 'easeInOutCubic',
					targets: '.intro-zoomer',
					scale: [
						{value: 1, duration: 1000},
						{value: 4.4, easing: 'easeInOutCubic', duration: 5000},
						{value: 4.6, easing: 'easeInOutCubic', duration: 4000},
					],
					duration: 5000,
				}, 3600)
				.add({
					targets: '.intro-headings, .intro-wipes',
					opacity: 1,
					duration: 2000,
				}, 6600)
				.add({
					easing: 'easeInOutSine',
					targets: '.intro-img.hero-img img',
					scale: [0.9, 1.1],
					translateY: [
						{value: '0%'},
						{value: '5%', duration: 4000},
						{value: '4%', duration: 2000},
						{value: '3%'},
					],
					duration: 5000,
				}, 6600)
				.add({
					targets: '.intro-heading',
					translateX: ['-50%', '-50%'],
					opacity: [
						{value: 0, duration: 0},
						{value: 1, duration: 1500},
						{value: 1, duration: 3000},
						{value: 0, duration: 1500},
					],
					translateY: [
						{value: '-20%', duration: 0},
						{value: '-50%', duration: 1500},
						{value: '-50%', duration: 3000},
						{value: '-100%', duration: 1500},
					],
					delay: anime.stagger(5000),
				}, 7600)
				.add({
					targets: '.intro-wipes .intro-wipe:not(.intro-wipe-0)',
					clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
					delay: anime.stagger(5000, {start: 5000}),
					duration: 1000,
				}, 7600)
				.add({
					targets: '.intro-wipes .intro-wipe:not(.intro-wipe-0) img',
					scale: [1, 1.2],
					translateY: ['0%', '-5%'],
					easing: 'linear',
					delay: anime.stagger(5000, {start: 5000}),
					duration: 6000,
				}, 7600)
				.add({
					targets: '.intro-tiles .main',
					translateY: ['0%', '-5%'],
					duration: 1000,
					easing: 'easeInCubic',
					delay: 5000,
				}, 7600)
				.add({
					targets: '.intro-wipe-1, .intro-wipe-2',
					translateY: ['0vh', '-30vh'],
					duration: 1300,
					easing: 'easeInCubic',
					delay: anime.stagger(5000, {start: 10000}),
				}, 7600)
				.add({
					targets: '.intro-logo',
					filter: ['blur(20px)', 'blur(0px)'],
					opacity: [0, 1],
					translateY: ['16px', '0px'],
					duration: 1000,
					
					begin: anim => {
						// @ts-ignore
						getEl('.intro-logo').style.display = 'block';
					},
				})
				.add({
					targets: '.intro-skip',
					translateX: ['-50%', '-50%'],
					translateY: ['0%', '20%'],
					opacity: [1, 0],
					//delay: -500,
					duration: 1000,
				}, 23000)
				.add({
					targets: '.intro-scroll',
					translateX: ['-50%', '-50%'],
					translateY: ['20%', '0%'],
					opacity: [0, 1],
					//delay: -500,
					duration: 2000,
				}, 23400)
				.add({
					targets: '.intro-headings',
					opacity: 0,
					duration: 1000,
				}, 22400);
		}
		
		//Uncomment this to attach an animation debugger.
		//const animDebug = new AnimationDebugger(this.mediaTimeline, getEl('.intro-sticky'));


		//If the screen is above the intro, then scroll it down to the intro. If it's below the intro, dont do anything.
		setTimeout(() => {
			const pos = this.elContainer.getBoundingClientRect();
			if (pos.top > 0) {
				if (Globals.isSafari) {
					window.scroll(0, pos.top + 1);
				} else {
					window.scrollBy({behavior: "instant", top: pos.top + 1});
				}
			}
		}, 200);

	}

	onExitedView(dir: ScrollDirection) {

	}

	onEnteredView(dir: ScrollDirection) {
		if (!this.mediaTimeline.completed) this.mediaTimeline.play();
	}

}
